import { AutogenLayoutIntercompanyBrokerageInfo } from "./autogen/AutogenLayoutIntercompanyBrokerageInfo";

export class IntercompanyBrokerageInfo extends AutogenLayoutIntercompanyBrokerageInfo {

}
